<div class="panel">
    <div class="dashboard">
        <app-dashboard [usuarioPanel]="usuarioPanel"></app-dashboard>
    </div>
    <div class="panelContent">
        <app-header-panel [usuarioPanelBinding]="usuarioPanel" [notificacionesPushBinding]="notificacionesPush"></app-header-panel>
        <app-form-usuario-panel [response]="response" [editar]="editar"></app-form-usuario-panel>
    </div>
</div>
